var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "welcome" }, [
      _c("h1", [_vm._v("欢迎来到纽尔蓝牙灯管理系统")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }